"use client";
import { useEffect, useState } from "react";
import "./ResetPassword.css";
import { CircularProgress } from "@mui/material";
import { Eye, EyeOff, } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import useUserStore from "../../store/useUserStore";
import Toast from "../toast/Toast";

export default function ResetPassword() {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);

    useEffect(() => {
        const data = queryParams.get("data");
        const decoded = data ? JSON.parse(base64DecodeUnicode(data)) : {};
        setEmail(decoded?.email)
        setPassword(decoded?.pass)
    }, [])

    const navigate = useNavigate();
    const { resetPassword } = useUserStore();
    const [showPassword, setShowPassword] = useState({
        new: false,
        confirm: false,
    });

    const base64DecodeUnicode = str => decodeURIComponent(escape(atob(str)));

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const handleCancelReset = () => {
        setNewPassword("")
        setConfirmPassword("")
        navigate('/dashboard')
    }

    const handleResetPassword = async () => {
        if (!email) {
            setToastMessage("Please enter your email");
            setShowToast(true);
            return
        }
        if (!password) {
            setToastMessage("Please enter old password");
            setShowToast(true);
            return
        }
        if (!newPassword) {
            setToastMessage("Please enter new password");
            setShowToast(true);
            return
        }
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;
        if (!passwordRegex.test(newPassword)) {
            setToastMessage("Password must be at least 8 characters, include one uppercase, one lowercase, and one special character.");
            setShowToast(true);
            return;
        }
        if (newPassword === password) {
            setToastMessage("New Password should be different to Old Password")
            setShowToast(true)
            return
        }
        if (newPassword != confirmPassword) {
            setToastMessage("confirm password is not matching");
            setShowToast(true);
            return
        }

        try {
            setIsLoading(true)
            const response = await resetPassword(email, password, newPassword);
            setIsLoading(false)
            setToastMessage(response.message);
            setShowToast(true);
            console.log(response)
        } catch (error) {
            setIsLoading(false)
            setToastMessage(error.message || "An unexpected error occurred during login.");
            setShowToast(true);
            console.error("Error in Manual Login", error)
        }

        handleCancelReset()
    }


    return (
        <div className="login-container">
            <Toast message={toastMessage} show={showToast} onClose={() => setShowToast(false)} />
            <div className="login-card">
                <div className="logo-container">
                    <svg
                        width="43"
                        height="43"
                        viewBox="0 0 43 43"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M21.5 0C26.4475 0 30.4583 4.01078 30.4583 8.95833L12.5417 8.95833C12.5417 4.01078 16.5524 0 21.5 0Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M10.75 21.5C10.75 15.5629 15.5629 10.75 21.5 10.75C27.4371 10.75 32.25 15.5629 32.25 21.5C32.25 27.4371 27.4371 32.25 21.5 32.25C15.5629 32.25 10.75 27.4371 10.75 21.5Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M8.95833 12.5417C4.01078 12.5417 0 16.5525 0 21.5C0 26.4475 4.01078 30.4583 8.95833 30.4583V12.5417Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M43 21.5C43 26.4476 38.9892 30.4583 34.0417 30.4583V12.5417C38.9892 12.5417 43 16.5525 43 21.5Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M12.5417 34.0417C12.5417 38.9892 16.5525 43 21.5 43C26.4475 43 30.4583 38.9892 30.4583 34.0417H12.5417Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M34.0417 3.58333C37.0102 3.58333 39.4167 5.9898 39.4167 8.95833H34.0417V3.58333Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M34.0417 39.4167C37.0102 39.4167 39.4167 37.0102 39.4167 34.0417H34.0417V39.4167Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M3.58333 8.95833C3.58333 5.9898 5.9898 3.58333 8.95833 3.58333V8.95833H3.58333Z"
                            fill="#0D9488"
                        />
                        <path
                            d="M3.58333 34.0417C3.58333 37.0102 5.9898 39.4167 8.95833 39.4167V34.0417H3.58333Z"
                            fill="#0D9488"
                        />
                    </svg>
                </div>
                <>
                    <h1 className="welcome-text">Password Reset</h1>
                    <div className="password-input-container">
                        <input
                            type={showPassword.new ? 'text' : 'password'}
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="input-login-container"
                            placeholder="New Password"
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => togglePasswordVisibility("new")}
                            aria-label={showPassword.new ? 'Hide password' : 'Show password'}
                        >
                            {showPassword.new ? (
                                <EyeOff size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </div>
                    <div className="password-input-container">
                        <input
                            type={showPassword.confirm ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="input-login-container"
                            placeholder="Confirm Password"
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => togglePasswordVisibility("confirm")}
                            aria-label={showPassword.confirm ? 'Hide password' : 'Show password'}
                        >
                            {showPassword.confirm ? (
                                <EyeOff size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </div>
                    <p className="password-instruction">Password must be at least 8 characters, include one uppercase, one lowercase, and one special character.</p>

                    <div className="reset-buttons">
                        <button onClick={handleResetPassword} className="credentials-button">Reset</button>
                    </div>
                </>
                {isLoading && (
                    <CircularProgress
                        size={30}
                        sx={{ position: "absolute", bottom: "5px", left: "50%" }}
                    />
                )}
            </div>
        </div>
    );
}
